import { useDispatch, useSelector } from 'react-redux'
import { ShowAllIndustryCheckbox } from '../../../ShowAllIndustryCheckbox'
import { changeIsShowData, selectIsShowData } from '../../store/slice'

export const ShowDataIndustry = () => {
  const dispatch = useDispatch()

  const isShowData = useSelector(selectIsShowData)

  const onClick = (isShow) => {
    dispatch(changeIsShowData(isShow))
  }

  return <ShowAllIndustryCheckbox isShow={isShowData} onClick={onClick} />
}
